(function() {
  'use strict';

  var PAGE_LOAD = Date.now();
  var MIN_HUMAN_MS = 1500;

  var LIMITS = {
    search:       { max: 3, windowSec: 10 },
    localization: { max: 2, windowSec: 30 }
  };

  function getTimestamps(key) {
    try {
      var raw = sessionStorage.getItem(key);
      return raw ? JSON.parse(raw) : [];
    } catch (e) { return []; }
  }

  function setTimestamps(key, arr) {
    try { sessionStorage.setItem(key, JSON.stringify(arr)); } catch (e) {}
  }

  function isRateLimited(category) {
    var cfg = LIMITS[category];
    if (!cfg) return false;
    var key = 'jj_rl_' + category;
    var now = Date.now();
    var cutoff = now - (cfg.windowSec * 1000);
    var timestamps = getTimestamps(key).filter(function(t) { return t > cutoff; });
    if (timestamps.length >= cfg.max) return true;
    timestamps.push(now);
    setTimestamps(key, timestamps);
    return false;
  }

  function injectHoneypot(form) {
    if (form.querySelector('.bot-guard-field')) return;
    var hp = document.createElement('input');
    hp.type = 'text';
    hp.name = 'website_url';
    hp.className = 'bot-guard-field';
    hp.setAttribute('tabindex', '-1');
    hp.setAttribute('autocomplete', 'off');
    hp.setAttribute('aria-hidden', 'true');
    form.appendChild(hp);
  }

  function guardForm(form, category) {
    form.addEventListener('submit', function(e) {
      var hp = form.querySelector('.bot-guard-field');
      if (hp && hp.value.length > 0) {
        e.preventDefault();
        e.stopImmediatePropagation();
        return false;
      }

      if ((Date.now() - PAGE_LOAD) < MIN_HUMAN_MS) {
        e.preventDefault();
        e.stopImmediatePropagation();
        return false;
      }

      if (isRateLimited(category)) {
        e.preventDefault();
        e.stopImmediatePropagation();

        var btn = form.querySelector('button[type="submit"], input[type="submit"]');
        if (btn && !btn.dataset.rlNotified) {
          btn.dataset.rlNotified = '1';
          var origText = btn.textContent;
          btn.textContent = 'Slow down...';
          setTimeout(function() {
            btn.textContent = origText;
            delete btn.dataset.rlNotified;
          }, 2000);
        }
        return false;
      }
    }, true);
  }

  function init() {
    var searchForms = document.querySelectorAll('.search-form, form[action*="/search"]');
    for (var i = 0; i < searchForms.length; i++) {
      injectHoneypot(searchForms[i]);
      guardForm(searchForms[i], 'search');
    }

    var locForms = document.querySelectorAll('form[action*="/localization"]');
    for (var j = 0; j < locForms.length; j++) {
      injectHoneypot(locForms[j]);
      guardForm(locForms[j], 'localization');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();